module.exports = __webpack_public_path__ + "img/main-hero-4.8fe2e2e6.jpg";